export enum FilterScopeOptions {
    PERSONAL = 'Personal',
    TEAM = 'Team'
}

export enum SectorFilterOptions {
    ALL = "All",
    FILTER = "Filter",
    NONE = "None"
}